
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/utmb-index/races/[race]",
      function () {
        return require("private-next-pages/utmb-index/races/[race].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/utmb-index/races/[race]"])
      });
    }
  